import { render } from "./StartDeletion.vue?vue&type=template&id=6c9136e0"
import script from "./StartDeletion.vue?vue&type=script&lang=js"
export * from "./StartDeletion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/windowOverlay/StartDeletion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c9136e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c9136e0', __exports__)) {
    api.reload('6c9136e0', __exports__)
  }
  
  module.hot.accept("./StartDeletion.vue?vue&type=template&id=6c9136e0", () => {
    api.rerender('6c9136e0', render)
  })

}


export default __exports__